import { Spin } from 'antd';
import { Suspense, lazy } from 'react';

import { useSearchParams } from '@suntex.core/nav';
import { Entities_Modules_Module } from '@suntex.fim/api-client';
import { useModuleBySlug } from '@suntex.fim/framework';

import { ModuleLayout } from '../components/ModuleLayout';

import { CDN_BASE, SOUND_DIRECTORY, useModuleViewProps } from './shared';

const FractionWheelsView = lazy(() =>
  import('@suntex.modules/fraction-wheels').then((m) => ({
    default: m.FractionWheelsView,
  })),
);
const K2UndoView = lazy(() =>
  import('@suntex.modules/k2-undo').then((m) => ({ default: m.K2UndoView })),
);

export function Games({ moduleSlug }: { moduleSlug: string }) {
  const module = useModuleBySlug(moduleSlug);
  let alertMessage: string = '';

  if (!module) {
    return <Spin />;
  }

  if (module.slug === 'fraction-wheels') {
    alertMessage =
      'If you are having trouble, try resetting your browser zoom to 100%.';
  }

  return (
    <>
      <ModuleLayout moduleId={module.id} alertMessage={alertMessage}>
        <Suspense fallback={<Spin />}>
          <GameView module={module} />
        </Suspense>
      </ModuleLayout>
    </>
  );
}

function GameView({ module }: { module: Entities_Modules_Module }) {
  const [searchParams] = useSearchParams();
  const moduleVariant = Number(searchParams.get('moduleVariant')) || 0;
  const viewProps = useModuleViewProps();

  const commonProps = {
    ...viewProps,
    module,
    moduleVariant,
    soundDirectory: SOUND_DIRECTORY,
    nextGameUrl: null,
    transformImageSource: (src: string) => CDN_BASE + src,
  };

  switch (module.slug) {
    case 'fraction-wheels':
      return <FractionWheelsView {...commonProps} />;
    case 'k2-undo':
      return <K2UndoView {...commonProps} />;
    default:
      return <div>Module not available</div>;
  }
}
